import type { ApiClient, TokenStore } from '@fidalia/api';
import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

export type RouterContext = {
  queryClient: QueryClient;
  tokens: TokenStore;
  /** Le client HTTP est dans le contexte pour que les gardes puissent précharger. */
  api: ApiClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: () => <div className="p-8 text-content-muted">Page introuvable.</div>,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV ? <ReactQueryDevtools buttonPosition="bottom-right" /> : null}
    </>
  );
}
